var render, staticRenderFns
import script from "./DraggableItem_workMan.vue?vue&type=script&lang=js"
export * from "./DraggableItem_workMan.vue?vue&type=script&lang=js"
import style0 from "./DraggableItem_workMan.vue?vue&type=style&index=0&id=240f2727&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240f2727",
  null
  
)

export default component.exports